import { SocketEvent } from "../SocketEvent";
import { SocketEventInterface } from "../SocketEventInterface";
import { SocketEventProcessorInterface } from "../SocketEventProcessorInterface";
import Constants from "../../Action/Constants";

class TransactionFileProgress extends SocketEvent implements SocketEventInterface {

  protected props: any;

  constructor() {
    super();
  }

  public process(props: SocketEventProcessorInterface): void {
    this.props.dispatch({
      type: Constants.PAGE_BANK_TRANSACTIONS_PROGRESS,
      payload: {
        id: props.res.id,
        total: props.res.total,
        current: props.res.current,
        countOfExistingPayments: props.res.countOfExistingPayments,
        countOfCreatedPayments: props.res.countOfCreatedPayments,
        countOfNotRecognizedPayments: props.res.countOfNotRecognizedPayments,
      }
    });
  }

}

export { TransactionFileProgress };
